import { CheckIcon } from "./ui/Icons";
import { LogoLockup } from "./Layout";

const POINTS = [
  "Columns matched by name — no manual mapping",
  "Accounts, contacts, invoices, bills and journals",
  "Sheets validated before anything is pushed",
];

/** Branded panel beside the sign-in / sign-up forms. */
export function AuthAside() {
  return (
    <div className="relative hidden w-[46%] max-w-[600px] shrink-0 overflow-hidden bg-ink-950 lg:block">
      {/* Ambient colour */}
      <div className="absolute -left-32 -top-32 h-[460px] w-[460px] rounded-full bg-brand-500/20 blur-[110px]" />
      <div className="absolute -bottom-40 -right-24 h-[420px] w-[420px] rounded-full bg-sky-500/10 blur-[110px]" />
      <div className="absolute inset-0 bg-grid opacity-[0.06]" />

      <div className="relative flex h-full flex-col justify-center p-14">
        {/* Panel sits on ink-950, so the notch border matches that, not the
            sidebar's ink-900. */}
        <LogoLockup notch="border-ink-950" size={44} label={false} />

        <h2 className="mt-9 max-w-[26rem] text-[38px] font-semibold leading-[1.1] tracking-tight text-white">
          Excel to
          <span className="bg-gradient-to-r from-brand-300 to-brand-500 bg-clip-text text-transparent">
            {" "}
            Naqood
          </span>
        </h2>

        <ul className="mt-9 space-y-4">
          {POINTS.map((p) => (
            <li key={p} className="flex items-start gap-3">
              <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-md bg-brand-500/15 text-brand-300 ring-1 ring-brand-400/25">
                <CheckIcon size={12} strokeWidth={3} />
              </span>
              <span className="text-[14px] leading-relaxed text-ink-400">{p}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
